
import { commonTypes } from './common';
import { executeEveryReducerParts, sortAlphabeticallyInitialState } from './utils/customCombineReducers';
import ApisNeedsOBDReducer, {
  initialState as apisNeedsObdInitialState,
  actions as apisNeedsObdActions,
} from './apisNeeds/apisNeedsObd';
import ApisNeedsAccountReducer, {
  initialState as apisNeedsAccountInitialState,
  actions as apisNeedsAccountActions,
  types as apisNeedsAccountTypes,
} from './apisNeeds/apisNeedsAccount';
import ApisNeedsClientInfoReducer, {
  initialState as apisNeedsClientInfoInitialState,
  actions as apisNeedsClientInfoActions,
  types as apisNeedsClientInfoTypes,
} from './apisNeeds/apisNeedsClientInfo';
import ApisNeedsPOTsReducer, {
  initialState as apisNeedsPOTsInitialState,
  actions as apisNeedsPOTsActions,
} from './apisNeeds/apisNeedsPOTs';
import ApisNeedsRiskScoringReducer, {
  initialState as apisNeedsRiskScoringInitialState,
  actions as apisNeedsRiskScoringActions,
} from './apisNeeds/apisNeedsRiskScoring';
import ApisNeedsMyProductsReducer, {
  initialState as apisNeedsMyProductsInitialState,
  actions as apisNeedsMyProductsActions,
} from './apisNeeds/apisNeedsMyProducts';
import ApisNeedsPpipReducer, {
  initialState as apisNeedsPpipInitialState,
  actions as apisNeedPpipActions,
} from './apisNeeds/apisNeedsPpip';
import ApisNeedsMobileInsuranceReducer, {
  initialState as apisNeedsMobileInsuranceInitialState,
  actions as apisNeedMobileInsuranceActions,
} from './apisNeeds/apisNeedsMobileInsurance';
import ApisNeedsAscertainReducer, {
  initialState as apisNeedsAscertainInitialState,
  actions as apisNeedAscertainActions,
} from './apisNeeds/apisNeedsAscertain';
import ApisNeedsInstallationReducer, {
  initialState as apisNeedsInstallationInitialState,
  actions as apisNeedInstallationActions,
} from './apisNeeds/apisNeedsInstallation';
import ApisNeedsR2RReducer, {
  initialState as apisNeedsR2RInitialState,
  actions as apisNeedR2RActions,
} from './apisNeeds/apisNeedsR2R';
import ApisNeedsVTLReducer, {
  initialState as apisNeedsVTLInitialState,
  actions as apisNeedVTLActions,
} from './apisNeeds/apisNeedsVTL';
import ApisNeedsTerminalDataReducer, {
  initialState as apisNeedsTerminalDataInitialState,
  actions as apisNeedTerminalDataActions,
} from './apisNeeds/apisNeedsTerminalData';
import ApisNeedsProductOfferingReducer, {
  initialState as apisNeedsProductOfferingInitialState,
  actions as apisNeedProductOfferingActions,
  types as apisNeedsProductOfferingTypes,
} from './apisNeeds/apisNeedsProductOffering';
import ApisNeedsPricesReducer, {
  initialState as apisNeedsPricesInitialState,
  actions as apisNeedPricesActions,
} from './apisNeeds/apisNeedsPrices';
import ApisNeedsRegisterReducer, {
  initialState as apisNeedsRegisterInitialState,
  actions as apisNeedRegisterActions,
} from './apisNeeds/apisNeedsRegister';
import ApisNeedsManualReducer, {
  initialState as apisNeedsManualInitialState,
  actions as apisNeedManualActions,
} from './apisNeeds/apisNeedsManual';

export const types = {
  ...apisNeedsAccountTypes,
  ...apisNeedsClientInfoTypes,
  ...apisNeedsProductOfferingTypes,
};

const messyInitialState = {
  ...apisNeedsAccountInitialState,
  ...apisNeedsClientInfoInitialState,
  ...apisNeedsPOTsInitialState,
  ...apisNeedsRiskScoringInitialState,
  ...apisNeedsMyProductsInitialState,
  ...apisNeedsPpipInitialState,
  ...apisNeedsMobileInsuranceInitialState,
  ...apisNeedsAscertainInitialState,
  ...apisNeedsInstallationInitialState,
  ...apisNeedsObdInitialState,
  ...apisNeedsR2RInitialState,
  ...apisNeedsVTLInitialState,
  ...apisNeedsTerminalDataInitialState,
  ...apisNeedsProductOfferingInitialState,
  ...apisNeedsPricesInitialState,
  ...apisNeedsRegisterInitialState,
  ...apisNeedsManualInitialState,
};

const initialState = sortAlphabeticallyInitialState(messyInitialState);

const reducerParts = [
  ApisNeedsOBDReducer,
  ApisNeedsAccountReducer,
  ApisNeedsClientInfoReducer,
  ApisNeedsPOTsReducer,
  ApisNeedsRiskScoringReducer,
  ApisNeedsMyProductsReducer,
  ApisNeedsPpipReducer,
  ApisNeedsMobileInsuranceReducer,
  ApisNeedsAscertainReducer,
  ApisNeedsInstallationReducer,
  ApisNeedsR2RReducer,
  ApisNeedsVTLReducer,
  ApisNeedsTerminalDataReducer,
  ApisNeedsProductOfferingReducer,
  ApisNeedsPricesReducer,
  ApisNeedsRegisterReducer,
  ApisNeedsManualReducer,
];

// eslint-disable-next-line @typescript-eslint/default-param-last
const ApisNeedsReducer = (state = JSON.parse(JSON.stringify(initialState)), action) => {
  const reducerPartsExecutionResult = executeEveryReducerParts(reducerParts, state, action);

  if (reducerPartsExecutionResult) {
    return reducerPartsExecutionResult;
  }

  switch (action.type) {
    case commonTypes.RESET_FLOW: {
      return {
        ...JSON.parse(JSON.stringify(initialState)),
        originalPermanentResidenceInfo: state.originalPermanentResidenceInfo,
        personalContactInfo: state.personalContactInfo,
        clientInfo: state.clientInfo,
      };
    }
    case commonTypes.RESET_ASCERTAIN: {
      return {
        ...state,
        addToCartNeeds: initialState.addToCartNeeds,
        getFeaturesNeeds: initialState.getFeaturesNeeds,
        selectElementsNeeds: initialState.selectElementsNeeds,
        selectElementsOptions: initialState.selectElementsOptions,
        selectElementsSecondaryOptions: initialState.selectElementsSecondaryOptions,
        ppipInfo: initialState.ppipInfo,
      };
    }
    default:
      return { ...state };
  }
};

export const actions = {
  ...apisNeedsObdActions,
  ...apisNeedsAccountActions,
  ...apisNeedsClientInfoActions,
  ...apisNeedsPOTsActions,
  ...apisNeedsRiskScoringActions,
  ...apisNeedsMyProductsActions,
  ...apisNeedPpipActions,
  ...apisNeedMobileInsuranceActions,
  ...apisNeedAscertainActions,
  ...apisNeedInstallationActions,
  ...apisNeedR2RActions,
  ...apisNeedVTLActions,
  ...apisNeedTerminalDataActions,
  ...apisNeedProductOfferingActions,
  ...apisNeedPricesActions,
  ...apisNeedRegisterActions,
  ...apisNeedManualActions,
};

export default ApisNeedsReducer;
